import axios from 'axios'
import config from '../../../../../conf.json'

const tasksVuex = {
	namespaced: true,
	state: {
		tasks: [],
		isReady: false,
		lastUpdated: null,
		advisors: [],
		advisorsReady: false,
	},
	mutations: {
		setTasks(state, data) {
			state.tasks = data
		},
		setIsReady(state, bool) {
			state.isReady = bool
		},
		setLastUpdated(state, timestamp) {
			state.lastUpdated = timestamp
		},
		setAdvisors(state, data) {
			state.advisors = data
		},
		setAdvisorsReady(state, bool) {
			state.advisorsReady = bool
		},
		clearState(state) {
			state.tasks = []
			state.isReady = false
			state.lastUpdated = null
		},
	},
	actions: {
		async clearState({ commit }) {
			commit('clearState')
		},
		async reloadTasks({ commit, dispatch }, options = {}) {
			commit('setIsReady', false)
			await dispatch('getTasks', options)
		},
		async getTasks({ state, commit, rootGetters }, options = {}) {
			// Return cached data if already loaded
			if (state.isReady) {
				return state.tasks
			}

			try {
				const idToken = await rootGetters['auth/idToken']
				const currentUserId = rootGetters['auth/uid']

				// Extract options with defaults
				const responsibleUserId = options.responsibleUserId || currentUserId
				const status = options.status || null // null means fetch all statuses

				// Build params - only include status if it has a value
				const params = { responsibleUserId: responsibleUserId }
				if (status) {
					params.status = status
				}

				const headers = {
					Authorization: 'Bearer ' + idToken,
					'Content-Type': 'application/json'
				}

				// Fetch both employee policy notes and company notes in parallel
				const [employeePolicyNotesResult, companyNotesResult] = await Promise.all([
					axios({
						url: config.firebaseConfig.apiURL + '/employeePolicy/notes/all',
						method: 'GET',
						headers: headers,
						params: params
					}),
					axios({
						url: config.firebaseConfig.apiURL + '/company/notes/all',
						method: 'GET',
						headers: headers,
						params: params
					})
				])

				// Combine both results
				const allTasks = [
					...employeePolicyNotesResult.data,
					...companyNotesResult.data
				]

				commit('setTasks', allTasks)
				commit('setIsReady', true)
				commit('setLastUpdated', Date.now())

				return allTasks
			} catch (error) {
				console.error('Error loading tasks:', error)
				commit('setIsReady', true) // Set ready even on error to prevent infinite loading
				throw error
			}
		},
		async getAdvisors({ state, commit, rootGetters }) {
			// Return cached data if already loaded
			if (state.advisorsReady) {
				return state.advisors
			}

			try {
				const idToken = await rootGetters['auth/idToken']

				const axiosOptions = {
					url: config.firebaseConfig.apiURL + '/user/filter/by-role',
					method: 'GET',
					headers: {
						Authorization: 'Bearer ' + idToken,
						'Content-Type': 'application/json'
					},
					params: {
						isAdmin: 'true',
						isAdvisor: 'true'
					}
				}

				const result = await axios(axiosOptions)
				commit('setAdvisors', result.data)
				commit('setAdvisorsReady', true)

				return result.data
			} catch (error) {
				console.error('Error loading advisors:', error)
				commit('setAdvisorsReady', true) // Set ready even on error to prevent infinite loading
				throw error
			}
		},
	},
	getters: {
		isReady(state) {
			return state.isReady
		},
		tasks(state) {
			return state.tasks
		},
		lastUpdated(state) {
			return state.lastUpdated
		},
		advisors(state) {
			return state.advisors
		},
		advisorsReady(state) {
			return state.advisorsReady
		},
	},
}

export default tasksVuex
